import React from 'react';
import { View, } from 'react-native';
import { withTheme } from '@rneui/themed';
import { FAIcon } from '../elements';
export const UnthemedCardOverlay = ({ isLocked = false, lockStyle, overlayContainerStyle, }) => {
    return (React.createElement(View, { style: overlayContainerStyle }, isLocked &&
        React.createElement(FAIcon, { name: "lock", style: lockStyle })));
};
export const CardOverlay = withTheme(UnthemedCardOverlay, 'CardOverlay');
//# sourceMappingURL=CardOverlay.js.map